@if ((isTokenValidationLoading$ | async) === false) {
  <img [src]="mercuryLogoPath" class="mercury-logo" alt="Mercury Logo" />
  <div class="col-12 body-medium text-tertiary subtitle-gap p-0">
    Recover Account
  </div>
  @if ((isInvitationModelValid$ | async) === true) {
    <div class="col-12 jumbo-medium text-primary title-gap p-0">
      Reset Password
    </div>
    <div class="col-12 body-medium text-tertiary paragraph-gap p-0">
      Please enter password and confirm your password
    </div>
    <form class="grid w-full m-0 p-0" [formGroup]="form">
      <div class="col-12 p-0" style="margin-bottom: 48px">
        <div class="form-group">
          <div class="field-label-medium text-tertiary mb-2">
            <label class="">New Password</label>
          </div>
          <div class="form-control p-fluid input-text">
            <p-password
              [strongRegex]="strongRegex"
              formControlName="password"
              [toggleMask]="true"
              inputStyleClass="w-full"
              appendTo="body"
              class="p-input-icon-right"
            >
              <ng-template #header>
                <span class="subtitle-small text-secondary">
                  Pick a password
                </span>
              </ng-template>
              <ng-template #footer>
                <p-divider></p-divider>

                <me-password-rules
                  [passwordControl]="password"
                ></me-password-rules>
              </ng-template>
            </p-password>
            <me-form-validation-message
              controlName="password"
              label="Password"
            ></me-form-validation-message>
          </div>
        </div>
      </div>

      <div class="col-12 p-0" style="margin-bottom: 48px">
        <div class="form-group">
          <div class="field-label-medium text-tertiary mb-2">
            <label class="">Confirm Password</label>
          </div>
          <div class="form-control p-fluid input-text">
            <p-password
              formControlName="passwordRepeat"
              [feedback]="false"
              [toggleMask]="true"
              inputStyleClass="w-full"
              class="p-input-icon-right"
            >
            </p-password>
            <me-form-validation-message
              controlName="passwordRepeat"
              label="Confirm password"
              [displayGroupErrors]="true"
            ></me-form-validation-message>
          </div>
        </div>
      </div>

      <div class="col-12 p-0">
        <button
          pButton
          class="p-button-primary button-text-medium w-full"
          [loading]="!!(isRequestInProgress$ | async)"
          [disabled]="
            (isRequestInProgress$ | async) === true ||
            form.invalid ||
            password.value !== passwordRepeat.value ||
            !token
          "
          (click)="
            enableRecaptchaFlag && !useTurnstile
              ? submitRequestWithCaptcha()
              : sendResetPasswordRequest()
          "
          type="submit"
        >
          <span pButtonLabel>Save</span>
        </button>
      </div>
    </form>
  } @else {
    <div class="col-12 jumbo-medium text-primary title-gap p-0">
      Link Invalid
    </div>
    <div class="col-12 body-medium text-tertiary description-gap p-0">
      This link has either expired or been used already. Please try again to
      receive another link.
    </div>

    <div class="col-12 p-0">
      <button
        pButton
        class="p-button-primary w-full button-text-medium"
        routerLink="/login"
      >
        <span pButtonLabel>Back to Login</span>
      </button>
    </div>
  }
}

@if (enableRecaptchaFlag) {
  @if (useTurnstile) {
    <div
      #turnstileRef
      class="turnstile-container flex justify-content-center mt-3"
    ></div>
  } @else {
    <re-captcha
      #captchaRef
      (resolved)="resolved($event)"
      [siteKey]="captchaPublicSiteKey"
      size="invisible"
    ></re-captcha>
  }
}
